import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Achievements from '@app/components/Landing/Achievements'
import CurrentTour from '@app/components/Landing/CurrentTour'
import Motivation from '@app/components/Landing/Motivation'
import Info from '@app/components/Landing/Info'
import About from '@app/components/Landing/About'
import Footer from '@app/components/Landing/Footer'
import SVG from "react-inlinesvg";
import { Subject, Dates, Timing } from '@app/components/shared/StateLabel/Label'

import Friendship from '@app/components/shared/StateLabel/Friendship'
import Timeline from '@app/components/shared/Timeline'
import Platform from '@app/components/Landing/Platform'
import StateLabel from '@app/components/shared/StateLabel'
import calendar from '@icons/calendar/yellow'
import classnames from "classnames";
import Rewards from "@app/components/Landing/Rewards";
import RewardsBlock from "../Rewarding";

const Home = ({global}) => {
  const date = I18n.l("date.formats.long", global.event.trial_tour_starts_at)

  const classes = classnames(
    'page', 'student-tasks-page',
    'student-tasks-page--landing'
  )

  const shouldShowTimeline = !global.event.afterMainTour
  const shouldShowRewardsBlock = !(global.event.afterMainTour && !global.event.isAwardsAvailable)

  return (
    <Fragment>
      {shouldShowTimeline && <Timeline event={global.event} />}
      {shouldShowRewardsBlock && <RewardsBlock event={global.event} />}
      <Achievements />
      <>
        <div className="section running-now-section" style={{paddingBottom: '30px'}}>
          <h1 className="plate-heading plate-heading--left">
            Practice Stage
          </h1>
          <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
            <div className="grid">
              <Subject event={global.event} tourName={'Warm-Up Stage'}/>
              <div className="grid">
                <Dates event={global.event} tour="trial"/>
                <Timing event={global.event} iconClassName="f--all-default"
                        textTiming={'Students can practise at their own pace with unlimited attempts'}/>
              </div>
            </div>
          </div>
        </div>
        <div className="section running-now-section" style={{paddingTop: 0, paddingBottom: '16px'}}>
          <h1 className="plate-heading plate-heading--left">
            Competition Stage
          </h1>
          <div className="plate plate--info plate--xl m-0 mt-2" style={{border: '1px solid black'}}>
            <div className="grid">
              <Subject event={global.event} tourName={'DinoMath Olympiad'}/>
              <div className="grid">
                <Dates event={global.event} tour="main"/>
                <Timing event={global.event} iconClassName="f--all-default" textTiming={'During this period, students can enter the Olympiad at any time. They will have 1\xa0hour to solve all tasks.'}/>
              </div>
            </div>
          </div>
        </div>
        <div className="section running-now-section" style={{paddingTop: 0}}>
          <div className="plate plate--info plate--xl m-0" style={{border: '1px solid black'}}>
            <div className="grid">
              <Subject event={global.event} tourName={'Final Round'}/>
              <div className="grid">
                <Dates event={global.event} tour="final"/>
                <Timing
                  event={global.event}
                  iconClassName="f--all-default"
                  textTiming={'During this period, the students who have scored the best in the previous round will be able to participate in quizzes with children from different schools in India.'}
                />
              </div>
            </div>
          </div>
        </div>
      </>
      <Rewards />
      <Motivation/>
      <Info global={global}/>
      <About/>
      <Footer/>
    </Fragment>
  )
}

Home.propTypes = {
  global: PropTypes.object.isRequired
}

export default Home
